import CorgeeStorageHelper from './CorgeeStorageHelper';

// Types
interface Layer {
  LayerId: number;
  Name?: string;
  LayerName?: string;
  [key: string]: any;
}

interface ConversationGroup {
  GroupId?: number;
  Name?: string;
  GroupName?: string;
  [key: string]: any;
}

interface HiddenLayer {
  LayerId: number;
  [key: string]: any;
}

/**
 * Filtra las capas visibles excluyendo las que están marcadas para ocultar
 * @param layers - Array de capas a filtrar
 * @returns Array de capas visibles
 */
export const getVisibleLayers = (layers?: Layer[] | null): Layer[] =>
{
  if (!layers || layers.length === 0)
  {
    return [];
  }

  const layersToHide = CorgeeStorageHelper.getLayersToHide() as HiddenLayer[] | null;

  if (!layersToHide || layersToHide.length === 0)
  {
    return layers;
  }

  const hiddenLayerIds = new Set(layersToHide.map(item => item.LayerId));

  return layers.filter(layer => !hiddenLayerIds.has(layer.LayerId));
};

/**
 * Obtiene los nombres de las capas como string separado por comas
 * @param layers - Array de capas
 * @returns String con nombres de capas separados por comas o "Not Set"
 */
export const getLayersName = (layers: Layer[]): string =>
{
  if (!layers || layers.length === 0)
  {
    return 'Not Set';
  }

  const layersNameArray = layers
    .map(layer => layer.Name || layer.LayerName)
    .filter((name): name is string => Boolean(name));

  return layersNameArray.length > 0 ? layersNameArray.join(', ') : 'Not Set';
};

/**
 * Obtiene los nombres de los grupos de conversación como string separado por comas
 * @param conversationGroups - Array de grupos de conversación
 * @returns String con nombres de grupos separados por comas o "Not Set"
 */
export const getGroupsNames = (conversationGroups: ConversationGroup[]): string =>
{
  if (!conversationGroups || conversationGroups.length === 0)
  {
    return 'Not Set';
  }

  const groupsNames = conversationGroups
    .map(group => group.Name || group.GroupName)
    .filter((name): name is string => Boolean(name));

  return groupsNames.length > 0 ? groupsNames.join(', ') : 'Not Set';
};

// Export de utilidades adicionales si son necesarias
export const layerUtils = {
  getVisibleLayers,
  getLayersName,
  getGroupsNames,
} as const;

export default layerUtils;
